import src from "IMAGE";
export default { src, width: 624, height: 160, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPElEQVR42hWLywrAMAzD+v8/ugeDpLbZ2CVuehA6CI3ILEkm2cBAWoKjDaDGOZ+Cdpz+cDWHf95+GXuqBeSDPTzG+/aEAAAAAElFTkSuQmCC"};
